import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "../firebase";
import axios from "axios";

let ringtone;

const playSound = () => {
  // stop previous sound (important)
  if (ringtone) {
    ringtone.pause();
    ringtone.currentTime = 0;
  }

  ringtone = new Audio("/notification.mp3");

  ringtone.loop = true; // 🔁 repeat 3 sec sound
  ringtone.play().catch(() => {});

  // ⏱ stop after 20 sec
  setTimeout(() => {
    ringtone.pause();
    ringtone.currentTime = 0;
  }, 20000);
};

export const setupFCM = async (authToken, addNotification) => {
  try {
    // 1. Ask permission
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.log("❌ Notification permission denied");
      return;
    }

    // 2. Get VAPID KEY from ENV ✅
    const vapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY;

    // 3. Get FCM token
    const fcmToken = await getToken(messaging, { vapidKey });

    console.log("✅ FCM TOKEN:", fcmToken);

    if (!fcmToken) return;

    // 4. API BASE URL from ENV ✅
    const BASE_URL = import.meta.env.VITE_BASE_URL;

    // 5. Save token to backend
    await axios.post(
      `${BASE_URL}/fcm/token`,
      { fcm_token: fcmToken },
      {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      }
    );

    console.log("✅ FCM token saved to DB");

    // 6. Listen notifications
    onMessage(messaging, (payload) => {
      console.log("📩 Notification:", payload);

      playSound(); // 🔔 sound

      addNotification?.(payload); // optional UI

      new Notification(payload.notification.title, {
        body: payload.notification.body
      });
    });

  } catch (err) {
    console.error("❌ FCM ERROR:", err);
  }
};